const EXAMPLES = [
  {
    id: 1,
    blocs: [
      {
        id: 1,
        width: '100%',
      },
    ],
  },
  {
    id: 2,
    blocs: [
      {
        id: 1,
        width: '49%',
      },
      {
        id: 2,
        width: '49%',
      },
    ],
  },
  {
    id: 3,
    blocs: [
      {
        id: 1,
        width: '32%',
      },
      {
        id: 2,
        width: '32%',
      },
      {
        id: 3,
        width: '32%',
      },
    ],
  },
  {
    id: 4,
    blocs: [
      {
        id: 1,
        width: '24%',
      },
      {
        id: 2,
        width: '24%',
      },
      {
        id: 3,
        width: '24%',
      },
      {
        id: 4,
        width: '24%',
      },
    ],
  },
  {
    id: 5,
    blocs: [
      {
        id: 1,
        width: '19%',
      },
      {
        id: 2,
        width: '19%',
      },
      {
        id: 3,
        width: '19%',
      },
      {
        id: 4,
        width: '19%',
      },
      {
        id: 5,
        width: '19%',
      },
    ],
  },
  {
    id: 6,
    blocs: [
      {
        id: 1,
        width: '15.5%',
      },
      {
        id: 2,
        width: '15.5%',
      },
      {
        id: 3,
        width: '15.5%',
      },
      {
        id: 4,
        width: '15.5%',
      },
      {
        id: 5,
        width: '15.5%',
      },
      {
        id: 6,
        width: '15.5%',
      },
    ],
  },
];

const COMPONENTS = [
  {
    id: 'textBlock',
    icon: 'text',
    text: 'Text',
  },
  {
    id: 'HeadingBlock',
    icon: 'heading',
    text: 'Heading',
  },
  {
    id: 'ButtonBlock',
    icon: 'button',
    text: 'Button',
  },
  {
    id: 'ImageBlock',
    icon: 'image',
    text: 'Image',
  },
  {
    id: 'DividerBlock',
    icon: 'divider',
    text: 'Divider',
  },
  {
    id: 'SpacerBlock',
    icon: 'spacer',
    text: 'Spacer',
  },
  // {
  //   id: 'SocialBlock',
  //   icon: SocialIcon,
  //   text: 'Social Networks',
  // },
  {
    id: 'FramesBlock',
    icon: 'blocks',
    text: 'Frames',
  },
  {
    id: 'ImagesBlock',
    icon: 'blocks',
    text: 'Proof Images',
  },
  {
    id: 'Header',
    icon: 'blocks',
    text: 'Header',
  },
  {
    id: 'CustomHeader',
    icon: 'blocks',
    text: 'Custom Header',
  },
  {
    id: 'Concierge',
    icon: 'blocks',
    text: 'Concierge',
  },
  {
    id: 'Icons',
    icon: 'blocks',
    text: 'Icons',
  },
  {
    id: 'PreFooter',
    icon: 'blocks',
    text: 'Pre Footer',
  },
  {
    id: 'Footer',
    icon: 'blocks',
    text: 'Footer',
  },
  {
    id: 'CustomFooter',
    icon: 'blocks',
    text: 'Custom Footer',
  },
  {
    id: 'InvoiceBlock',
    icon: 'blocks',
    text: 'Invoice',
  },
];

const STYLE_LIST = {
  textBlock: {
    id: 'textBlock',
    list: [
      {
        title: 'Font size',
        name: 'font-size',
        postfix: 'px',
      },
      {
        title: 'Line Height',
        name: 'line-height',
        postfix: '',
      },
      {
        title: 'Color',
        name: 'color',
        postfix: '',
        isColor: true,
      },
      {
        title: 'Font weight',
        name: 'font-weight',
        postfix: '',
        options: [100, 200, 300, 400, 500, 600, 700, 800, 900],
      },
      {
        title: 'Text align',
        name: 'text-align',
        postfix: '',
        options: ['left', 'center', 'right'],
      },
      {
        title: 'Italic',
        name: 'font-style',
        postfix: 'italic',
        isCheckbox: true,
      },
      {
        title: 'Underline',
        name: 'text-decoration',
        postfix: 'underline',
        isCheckbox: true,
      },
    ],
    columnList: [
      {
        title: 'Padding Top',
        name: 'padding-top',
        postfix: 'px',
      },
      {
        title: 'Padding Bottom',
        name: 'padding-bottom',
        postfix: 'px',
      },
      {
        title: 'Padding Left',
        name: 'padding-left',
        postfix: 'px',
      },
      {
        title: 'Padding Right',
        name: 'padding-right',
        postfix: 'px',
      },
    ],
  },
  HeadingBlock: {
    id: 'HeadingBlock',
    list: [
      {
        title: 'Font size',
        name: 'font-size',
        postfix: 'px',
      },
      {
        title: 'Line Height',
        name: 'line-height',
        postfix: '',
      },
      {
        title: 'Color',
        name: 'color',
        postfix: '',
        isColor: true,
      },
      {
        title: 'Font weight',
        name: 'font-weight',
        postfix: '',
        options: [100, 200, 300, 400, 500, 600, 700, 800, 900],
      },
    ],
    columnList: [
      {
        title: 'Padding Top',
        name: 'padding-top',
        postfix: 'px',
      },
      {
        title: 'Padding Bottom',
        name: 'padding-bottom',
        postfix: 'px',
      },
      {
        title: 'Padding Left',
        name: 'padding-left',
        postfix: 'px',
      },
      {
        title: 'Padding Right',
        name: 'padding-right',
        postfix: 'px',
      },
    ],
  },
  ButtonBlock: {
    id: 'ButtonBlock',
    list: [
      {
        title: 'Font size',
        name: 'font-size',
        postfix: 'px',
      },
      {
        title: 'Color',
        name: 'color',
        postfix: '',
        isColor: true,
      },
      {
        title: 'Font weight',
        name: 'font-weight',
        postfix: '',
        options: [100, 200, 300, 400, 500, 600, 700, 800, 900],
      },
      {
        title: 'Italic',
        name: 'font-style',
        postfix: 'italic',
        isCheckbox: true,
      },
      {
        title: 'Underline',
        name: 'text-decoration',
        postfix: 'underline',
        isCheckbox: true,
      },
      {
        title: 'Background color',
        name: 'background-color',
        postfix: '',
        isColor: true,
      },
      {
        title: 'Border color',
        name: 'border',
        postfix: '',
        isColor: true,
      },
    ],
    columnList: [
      {
        title: 'Padding Top',
        name: 'padding-top',
        postfix: 'px',
      },
      {
        title: 'Padding Bottom',
        name: 'padding-bottom',
        postfix: 'px',
      },
      {
        title: 'Padding Left',
        name: 'padding-left',
        postfix: 'px',
      },
      {
        title: 'Padding Right',
        name: 'padding-right',
        postfix: 'px',
      },
    ],
  },
  DividerBlock: {
    id: 'DividerBlock',
    list: [
      {
        title: 'Color',
        name: 'border-color',
        postfix: '',
        isColor: true,
      },
      {
        title: 'Height',
        name: 'border-width',
        postfix: 'px',
      },
    ],
  },

};

const LINK_LIST = [
  {
    value: 'orderDetailsUrl',
    label: 'Order details',
    text: 'Order details',
  },
  {
    value: 'trackPageUrl',
    label: 'Track page',
    text: 'Track page',
  },
  {
    value: 'memoyaCloudLink',
    label: 'Cloud link',
    text: 'Cloud link',
  },
  {
    value: 'contactUsLink',
    label: 'Contact Page',
    text: 'Contact Page',
  },
  {
    value: 'proofPageLink',
    label: 'Proof page',
    text: 'Proof page',
  },
];

const GEN_LINKS = [
  {
    value: '{{baseUrl}}/account/?main=orderDetails&tab=orderDetails&order={{orderId}}&email=true',
    label: 'Message pop up',
    text: 'Message pop up',
    mask: 'messagePopup',
  },
  {
    value: '{{baseUrl}}/account/?main=orderDetails&tab=orderDetails&order={{orderId}}&payment=true',
    label: 'Pay balance pop up',
    text: 'Pay balance pop up',
    mask: 'payBalancePopup',
  },
  {
    value: 'https://www.google.com/maps/place/1000+Clint+Moore+Rd+%23+208,+Boca+Raton,+FL+33487',
    label: 'Google Maps',
    text: 'Google Maps',
    mask: 'googleMaps',
  },
  {
    value: '{{baseUrl}}/login/',
    label: 'Login Page',
    text: 'Login Page',
    mask: 'loginPage',
  },
  {
    value: '{{baseUrl}}/login/?forgot=true',
    label: 'Reset Password',
    text: 'Reset Password',
    mask: 'resetPassword',
  },
  {
    value: '{{baseUrl}}/account/?main=myFiles&tab=myFiles&cloudPopup=true',
    label: 'Reset Password',
    text: 'Reset Password',
    mask: 'cloudSubscribe',
  },
  {
    value: '{{baseUrl}}/account/?main=account&tab=payment',
    label: 'User Payment Info',
    text: 'User Payment Info',
    mask: 'userPaymentInfo',
  },
  {
    value: 'https://pm.foreverstudios.com/main/projects/{{projectId}}',
    label: 'PM project link',
    text: 'PM project link',
    mask: 'pmProjectLink',
  },
  {
    value: '{{baseUrl}}/account/?main=createWizard&tab=create&pageKey=proof',
    label: 'Make art page',
    text: 'Make art page',
    mask: 'makeArtPage',
  },
];

const CONSTANTS = [
  {
    value: 'firstName',
    label: 'First Name',
    text: 'First Name',
  },
  {
    value: 'Date',
    label: 'date',
    text: 'date',
  },
  {
    value: 'message',
    label: 'Message',
    text: 'Message',
  },
  {
    value: 'orderId',
    label: 'Order ID',
    text: 'Order ID',
  },
  {
    value: 'expirationDate',
    label: 'Expiration cloud date',
    text: 'Expiration cloud date',
  },
];

const EDIT = 'Edit';
const CREATE_NEW = 'Create new';
const CLOSE = 'Close';

const TYPES = [
  {
    value: 'new_order',
    label: 'New Order',
    text: 'New Order',
  },
  {
    value: 'receive',
    label: 'Receive',
    text: 'Receive',
  },
  {
    value: 'enhance',
    label: 'Enhance',
    text: 'Enhance',
  },
  {
    value: 'create',
    label: 'Create',
    text: 'Create',
  },
  {
    value: 'gift_card',
    label: 'Gift Card',
    text: 'Gift Card',
  },
  {
    value: 'wrapper',
    label: 'Gift wrapping',
    text: 'Gift wrapping',
  },
  {
    value: 'digitize',
    label: 'Digitize',
    text: 'Digitize',
  },
  {
    value: 'qa',
    label: 'QA',
    text: 'QA',
  },
  {
    value: 'delivery',
    label: 'Delivery',
    text: 'Delivery',
  },
  {
    value: 'forever_cloud',
    label: 'Forever cloud',
    text: 'Forever cloud',
  },
  {
    value: 'communications',
    label: 'Communications',
    text: 'Communications',
  },
  {
    value: 'messages',
    label: 'Messages',
    text: 'Messages',
  },
  {
    value: 'other',
    label: 'Other',
    text: 'Other',
  },
  {
    value: 'hardcode',
    label: 'Hardcode',
    text: 'Hardcode',
  },
];

const REQUIRED_FIELDS = {
  'approved-confirmation.html': {
    constants: [{ value: 'firstName', label: 'First Name' }],
    links: [
      { label: 'Create Art Constructor Link', value: 'createArtConstructorLink' },
      { label: 'Make payment link', value: 'makePaymentLink' },
    ],
  },
  'approved-cropped.html': {
    constants: [{ value: 'firstName', label: 'First Name' }],
    links: [
      { label: 'Create Art Constructor Link', value: 'createArtConstructorLink' },
      { label: 'Make payment link', value: 'makePaymentLink' },
    ],
  },
  'assignment/assignment-assigned-to-pm-user.html': {
    constants: [
      { value: 'orderId', label: 'Order id' },
      { value: 'assignmentName', label: 'Assignment name' },
      { value: 'startDate', label: 'Start date' },
      { value: 'endDate', label: 'End date' },
    ],
    links: [{ value: 'projectLink', label: 'PM Subtask link' }],
  },
  'awaiting-approval-reminder.html': {
    constants: [{ value: 'firstName', label: 'First Name' }],
    links: [{ value: 'projectLink', label: 'Project link' }],
    components: [{ value: 'ImagesBlock', label: 'Images block' }],
  },
  'awaiting-approval.html': {
    constants: [{ value: 'firstName', label: 'First Name' }],
    links: [{ value: 'projectLink', label: 'Project link' }],
    components: [{ value: 'ImagesBlock', label: 'Images block' }],
  },
  'awaiting-email-photo-reminder.html': {
    constants: [{ value: 'firstName', label: 'First Name' }],
  },
  'awaiting-payment-reminder.html': {
    constants: [{ value: 'firstName', label: 'First Name' }],
    links: [{ label: 'Make payment link', value: 'makePaymentLink' }],
  },
  'balance-paid.html': {
    constants: [{ value: 'firstName', label: 'First Name' }],
  },
  'contact-submission-confirmation.html': {
    constants: [
      { value: 'firstName', label: 'First Name' },
      { value: 'name', label: 'Name' },
      { value: 'email', label: 'Email' },
      { value: 'typeOfInquiry', label: 'Type of inquiry' },
      { value: 'question', label: 'Question' },
    ],
  },
  'contact-information-for-admin.html': {
    constants: [
      { value: 'firstName', label: 'First Name' },
      { value: 'name', label: 'Name' },
      { value: 'email', label: 'Email' },
      { value: 'typeOfInquiry', label: 'Type of inquiry' },
      { value: 'question', label: 'Question' },
    ],
  },
  'crop-reminder.html': {
    constants: [{ value: 'firstName', label: 'First Name' }],
    links: [
      { label: 'Create Art Constructor Link', value: 'createArtConstructorLink' },
      { label: 'Proof page link', value: 'proofPageLink' },
    ],
  },
  'file-delivery.html': {
    constants: [{ value: 'firstName', label: 'First Name' }],
    links: [{ value: 'memoyaCloudLink', label: 'Memoya cloud link' }],
  },
  'kit-delivered-reminder.html': {
    constants: [{ value: 'firstName', label: 'First Name' }],
  },
  'kit-received.html': {
    constants: [{ value: 'firstName', label: 'First Name' }],
  },
  'kit-sent.html': {
    constants: [{ value: 'firstName', label: 'First Name' }],
    links: [{ value: 'trackPageUrl', label: 'Track page url' }],
  },
  'memoya-cloud-before-expiration.html': {
    constants: [
      { value: 'firstName', label: 'First Name' },
      { value: 'expirationDate', label: 'Expiration cloud date' },
    ],
  },
  'memoya-cloud-limited-access.html': {
    constants: [{ value: 'firstName', label: 'First Name' }],
  },
  'memoya-cloud-no-access.html': {
    constants: [
      { value: 'firstName', label: 'First Name' },
      { value: 'expirationDate', label: 'Expiration cloud date' },
    ],
  },
  'new-message-chat.html': {
    constants: [{ value: 'firstName', label: 'First Name' }],
    links: [
      { value: 'messagesUrl', label: 'Messages url' },
      { value: 'fromUser.firstName', label: 'From first name' },
      { value: 'fromUser.lastName', label: 'From last name' },
      { value: 'orderId', label: 'Order id' },
    ],
  },
  'new-message-from-memoya.html': {
    constants: [{ value: 'firstName', label: 'First Name' }],
  },
  'new-user.html': {
    constants: [
      { value: 'firstName', label: 'First Name' },
      { value: 'email', label: 'Email' },
      { value: 'password', label: 'Password' },
    ],
    links: [{ value: 'changePasswordLink', label: 'Change password link' }],
  },
  'newsletter-submission-confirmation.html': {
    constants: [{ value: 'firstName', label: 'First Name' }],
  },
  'order/local-pick-up-scheduled.html': {
    constants: [
      { value: 'firstName', label: 'First Name' },
      { value: 'scheduledDate', label: 'Scheduled date' },
      { value: 'scheduledTimeStart', label: 'Scheduled time start' },
      { value: 'scheduledTimeEnd', label: 'Scheduled time end' },
      { value: 'shippingAddress', label: 'Shipping address' },
    ],
    components: [{ value: 'InvoiceBlock', label: 'Invoice' }],
  },
  'order/new-order-boca-raton-store-drop-off-reminder.html': {
    constants: [{ value: 'firstName', label: 'First Name' }],
    links: [{ value: 'contactUsLink', label: 'Contact us link' }],
    components: [{ value: 'InvoiceBlock', label: 'Invoice' }],
  },
  'order/new-order-boca-raton-store-drop-off.html': {
    constants: [{ value: 'firstName', label: 'First Name' }],
    links: [{ value: 'contactUsLink', label: 'Contact us link' }],
    components: [{ value: 'InvoiceBlock', label: 'Invoice' }],
  },
  'order/new-order-payment-failed.html': {
    constants: [{ value: 'firstName', label: 'First Name' }],
    links: [{ value: 'paymentUrl', label: 'Payment url' }],
    components: [{ value: 'InvoiceBlock', label: 'Invoice' }],
  },
  'order/new-order-receipt-email-later.html': {
    constants: [{ value: 'firstName', label: 'First Name' }],
    components: [{ value: 'InvoiceBlock', label: 'Invoice' }],
  },
  'order/new-order-receipt-enhance.html': {
    constants: [{ value: 'firstName', label: 'First Name' }],
    components: [{ value: 'firstName', label: 'First Name' }],
  },
  'order/new-order-receipt-gift-card.html': {
    constants: [{ value: 'firstName', label: 'First Name' }],
    components: [{ value: 'InvoiceBlock', label: 'Invoice' }],
  },
  'order/new-order-receipt-in-store.html': {
    constants: [{ value: 'firstName', label: 'First Name' }],
    components: [{ value: 'InvoiceBlock', label: 'Invoice' }],
  },
  'order/new-order-receipt-kit.html': {
    constants: [{ value: 'firstName', label: 'First Name' }],
    components: [{ value: 'InvoiceBlock', label: 'Invoice' }],
  },
  'order/new-order-receipt-local-pick-up.html': {
    constants: [{ value: 'firstName', name: 'First Name' }],
    components: [{ value: 'InvoiceBlock', label: 'Invoice' }],
  },
  'order/new-order-receipt-photo-art.html': {
    constants: [{ value: 'firstName', label: 'First Name' }],
    components: [{ value: 'InvoiceBlock', label: 'Invoice' }],
  },
  'order/order-change-request-received.html': {
    constants: [
      { value: 'firstName', label: 'First Name' },
      { value: 'orderDate', label: 'Order date' },
      { value: 'orderId', label: 'Order id' },
      { value: 'submissionRequestDate', label: 'Submission request date' },
      { value: 'listOfChangesRequested', label: 'List of changes requested' },
    ],
  },
  'order/order-complete-boca-raton-store-drop-off-in-store-reminder.html': {
    constants: [{ value: 'firstName', label: 'First Name' }],
    links: [{ value: 'contactUsLink', label: 'Contact us link' }],
    components: [{ value: 'InvoiceBlock', label: 'Invoice' }],
  },
  'order/order-complete-boca-raton-store-drop-off-in-store.html': {
    constants: [{ value: 'firstName', label: 'First Name' }],
    links: [{ value: 'contactUsLink', label: 'Contact us link' }],
    components: [{ value: 'InvoiceBlock', label: 'Invoice' }],
  },
  'order/order-complete-schedule-drop-off.html': {
    constants: [
      { value: 'firstName', label: 'First Name' },
      { value: 'scheduledDate', label: 'Scheduled date' },
      { value: 'scheduledTimeStart', label: 'Scheduled time start' },
      { value: 'scheduledTimeEnd', label: 'Scheduled time end' },
      { value: 'shippingAddress', label: 'Shipping address' },
    ],
    links: [{ value: 'contactUsLink', label: 'Contact us link' }],
    components: [{ value: 'InvoiceBlock', label: 'Invoice' }],
  },
  'order/order-shipped.html': {
    constants: [{ value: 'firstName', label: 'First Name' }],
    links: [{ value: 'trackPageUrl', label: 'Track page url' }],
    components: [{ value: 'InvoiceBlock', label: 'Invoice' }],
  },
  'order/order-updated-balance-due.html': {
    constants: [{ value: 'firstName', label: 'First Name' }],
    links: [{ value: 'makePaymentLink', label: 'Make payment link' }],
    components: [{ value: 'InvoiceBlock', label: 'Invoice' }],
  },
  'order/order-updated-balance.html': {
    constants: [{ value: 'firstName', label: 'First Name' }],
    links: [{ value: 'makePaymentLink', label: 'Make payment link' }],
    components: [{ value: 'InvoiceBlock', label: 'Invoice' }],
  },
  'order/order-updated.html': {
    constants: [{ value: 'firstName', label: 'First Name' }],
    components: [{ value: 'InvoiceBlock', label: 'Invoice' }],
  },
  'order/send-invoice.html': {
    constants: [{ value: 'firstName', label: 'First Name' }],
    components: [{ value: 'InvoiceBlock', label: 'Invoice' }],
  },
  'order-complete-boca-raton-store-drop-off-in-store-reminder.html': {
    constants: [{ value: 'firstName', label: 'First Name' }],
    links: [{ value: 'contactUsLink', label: 'Contact us link' }],
    components: [{ value: 'InvoiceBlock', label: 'Invoice' }],
  },
  'order-processing.html': {
    constants: [{ value: 'firstName', label: 'First Name' }],
    components: [{ value: 'InvoiceBlock', label: 'Invoice' }],
  },
  'refunds.html': {
    constants: [{ value: 'firstName', label: 'First Name' }],
    links: [{ value: 'makePaymentLink', label: 'Make payment link' }],
    components: [{ value: 'InvoiceBlock', label: 'Invoice' }],
  },
  'renewing-subscription.html': {
    constants: [{ value: 'firstName', label: 'First Name' }],
  },
  'reset-pass-confirm.html': {
    constants: [
      { value: 'firstName', label: 'First Name' },
      { value: 'email', label: 'Email' },
      { value: 'password', label: 'Password' },
    ],
  },
  'reset-password.html': {
    constants: [
      { value: 'firstName', label: 'First Name' },
      { value: 'email', label: 'Email' },
    ],
    links: [{ value: 'changePasswordLink', label: 'Change password link' }],
  },
  'revision-request-received.html': {
    constants: [{ value: 'firstName', label: 'First Name' }],
  },
  'share-media.html': {
    constants: [
      { value: 'firstName', label: 'First Name' },
      { value: 'firstNameShare', label: 'First name share' },
      { value: 'sharingText', label: 'Sharing text' },
    ],
    links: [{ value: 'linkToSharedPage', label: 'Link to shared page' }],
  },
  'ship-kit-delivered.html': {
    constants: [{ value: 'firstName', label: 'First Name' }],
    components: [{ value: 'InvoiceBlock', label: 'Invoice' }],
  },
};

const DESCRIPTION_ENTER_VARIABLE = 'Enter {{ to add a variable.To delete a variable, erase everything from {{ to }}';
const DESCRIPTION_ENTER_LINK = 'Enter [[ to add a link. To delete a link, erase everything from [[ to ]]';
const DESCRIPTION_ENTER_CUSTOM_LINK = 'Enter << to add a CUSTOM link.To delete a link, erase everything from << to >> ';
const COMMERCIAL_TYPES = [
  {
    value: 1,
    label: 'Consumer',
    text: 'Consumer',
  },
  {
    value: 2,
    label: 'Commercial',
    text: 'Commercial',
  },
];

export {
  EXAMPLES,
  COMPONENTS,
  STYLE_LIST,
  LINK_LIST,
  CONSTANTS,
  EDIT,
  CREATE_NEW,
  CLOSE,
  TYPES,
  GEN_LINKS,
  REQUIRED_FIELDS,
  DESCRIPTION_ENTER_VARIABLE,
  DESCRIPTION_ENTER_LINK,
  DESCRIPTION_ENTER_CUSTOM_LINK,
  COMMERCIAL_TYPES,
};
